import { Link, Outlet, useParams } from "react-router";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "@/shared/components/ui/breadcrumb";
import t from "@/lang/lang";
import {
  useQpmCatalogGetQuery,
  useQpmCatalogItemGetByBaseQuery,
} from "@/services/backend/qpm/catalog/api/catalog-api";
import { Card, CardContent } from "@/shared/components/ui/card";
import { MonitorTypeUtil } from "@/services/backend/qpm/lib/monitor-type-util";
import { monitorTypeToQuery } from "@/routes/base-data/processes/qpm/catalog/monitor-type-query";

export function CatalogRoute() {
  const { catalogId, monitorId } = useParams();
  const basePath = "/base-data/processes/qpm";

  const { data: catalog } = useQpmCatalogGetQuery(
    { id: catalogId! },
    { skip: !catalogId },
  );

  // In catalog routes, the URL segment `monitorId` is the base monitor id.
  const { data: catalogItem } = useQpmCatalogItemGetByBaseQuery(
    { catalogId: catalogId!, baseMonitorId: monitorId! },
    { skip: !catalogId || !monitorId },
  );

  const snap = catalogItem?.snapshot;

  return (
    <Card>
      <CardContent>
        <Breadcrumb>
          <BreadcrumbList>
            {!catalogId && (
              <BreadcrumbItem>
                <BreadcrumbPage>{t("Katalogübersicht")}</BreadcrumbPage>
              </BreadcrumbItem>
            )}
            {catalogId && catalog && (
              <>
                <BreadcrumbItem>
                  <BreadcrumbLink asChild>
                    <Link to={`${basePath}/catalog`}>
                      {t("Katalogübersicht")}
                    </Link>
                  </BreadcrumbLink>
                </BreadcrumbItem>
                <BreadcrumbSeparator />
                <BreadcrumbItem>
                  {monitorId && snap && (
                    <BreadcrumbLink asChild>
                      <Link to={`${basePath}/catalog/${catalogId}`}>
                        {catalog?.name || t("Katalog")}
                      </Link>
                    </BreadcrumbLink>
                  )}
                  {!(monitorId && snap) && (
                    <BreadcrumbPage>
                      {catalog?.name || t("Katalog")}
                    </BreadcrumbPage>
                  )}
                </BreadcrumbItem>
                {monitorId && snap && (
                  <>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                      <BreadcrumbLink asChild>
                        <Link
                          to={`${basePath}/catalog/${catalogId}?type=${monitorTypeToQuery(
                            snap.type,
                          )}`}
                        >
                          {MonitorTypeUtil.toLongString(snap.type)}
                        </Link>
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                      <BreadcrumbPage>
                        {snap.name || t("Monitor")}
                      </BreadcrumbPage>
                    </BreadcrumbItem>
                  </>
                )}
              </>
            )}
          </BreadcrumbList>
        </Breadcrumb>
      </CardContent>
      <Outlet />
    </Card>
  );
}
